import { BASE_API_URL } from './index';

export const baseExporterEndpoint = `${BASE_API_URL}/exporter`;
export const getCancelExportEndpoint = (exportFileId) => `${baseExporterEndpoint}/${exportFileId}/cancel/`;
